var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import * as React from 'react';
import { InlineChildren, Stack, StackChildren, Text, } from '@doordash/design-language';
import Button from '@doordash/component-button';
import styled from 'styled-components';
import { SelectionTile } from './SelectionTile';
import { SelectionPageData } from '../EmOnboardingPageData';
import { EXTERNAL_ROUTES } from '../../../../constants/values';
import track from '../../../../utils/track';
import { OnboardingEvents } from '../../../../constants/events';
var MarketplaceDisplayUrl = 'www.doordash.com';
var SelectionContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  max-width: 800px;\n  width: 90%;\n"], ["\n  max-width: 800px;\n  width: 90%;\n"])));
export var SelectSetupContainer = function (_a) {
    var onSelectedSetupOptionId = _a.onSelectedSetupOptionId;
    var _b = __read(React.useState(null), 2), selectedTileId = _b[0], setSelectedTileId = _b[1];
    React.useEffect(function () {
        track(OnboardingEvents.SELECTION_PAGE_VIEW);
    }, []);
    var onContinue = function () {
        track(OnboardingEvents.SETUP_SELECTED_SUBMIT, {
            setup: selectedTileId,
        });
        onSelectedSetupOptionId(selectedTileId);
    };
    return (React.createElement(SelectionContainer, null,
        React.createElement(StackChildren, null,
            React.createElement(Stack, { size: Stack.Sizes.XLarge },
                React.createElement(Text, { styles: Text.Styles.PageTitle2 }, SelectionPageData.title)),
            React.createElement(InlineChildren, { justifyContent: InlineChildren.Justification.SpaceBetween }, SelectionPageData.selectionTiles.map(function (tile) { return (React.createElement(SelectionTile, { key: tile.id, isSelected: selectedTileId === tile.id, id: tile.id, title: tile.title, description: tile.description, imageUrl: tile.imageUrl, tag: tile.tag, onSelect: function (tileId) { return setSelectedTileId(tileId); } })); })),
            React.createElement(Text, { styles: Text.Styles.Body2 },
                SelectionPageData.helperText,
                ' ',
                React.createElement("a", { href: EXTERNAL_ROUTES.MARKETPLACE, target: "_blank", rel: "noopener noreferrer", onClick: function () {
                        track(OnboardingEvents.ACTIONS_CLICK, { action: 'marketplace' });
                    } }, MarketplaceDisplayUrl)),
            React.createElement(InlineChildren, { justifyContent: InlineChildren.Justification.FlexEnd },
                React.createElement(Button, { size: Button.Sizes.Small, isInline: true, onClick: onContinue, isDisabled: !selectedTileId, type: Button.Types.Primary }, SelectionPageData.actionText)))));
};
export default SelectSetupContainer;
var templateObject_1;
